import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	notifyContainer: {
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(2)
	},
	formControl: {
		marginBottom: theme.spacing(1)
	},
	textArea: {
		marginTop: theme.spacing(2)
	},
	executeButton: {
		marginTop: theme.spacing(2),
		alignSelf: "flex-start"
	}
}))

export default useStyles
